import { blinkConstants } from '@thoughtspot/blink-constants';
import { overrideEmptyWithValue, overrideNullWithValue, } from '@thoughtspot/session-service';
import { strings } from '@thoughtspot/translations';
const getNullValuePlaceHolder = () => {
    const overrideValue = overrideNullWithValue();
    if (overrideValue !== null && overrideValue !== undefined) {
        return overrideValue;
    }
    return strings.NULL_VALUE_PLACEHOLDER_LABEL;
};
const getEmptyValuePlaceHolder = () => {
    const overrideValue = overrideEmptyWithValue();
    if (overrideValue !== null && overrideValue !== undefined) {
        return overrideValue;
    }
    return strings.EMPTY_VALUE_PLACEHOLDER_LABEL;
};
export function getSpecialFormatData(value) {
    if (value === getNullValuePlaceHolder() ||
        value === getEmptyValuePlaceHolder()) {
        return value;
    }
    if (value === blinkConstants.SPECIAL_VALUE_UNAVAILABLE) {
        return strings.UNAVAILABLE_COLUMN_SAMPLE_VALUE;
    }
    if (value === null || value === undefined) {
        return getNullValuePlaceHolder();
    }
    if (typeof value === 'string' && value.trim() === '') {
        return getEmptyValuePlaceHolder();
    }
    if (value instanceof Array) {
        if (!value.length || value[0] === null || value[0] === undefined) {
            return strings.NULL_VALUE_PLACEHOLDER_LABEL;
        }
        switch (value[0]) {
            case 'NaN':
                return 'NaN';
            case 'Infinity':
                return 'Infinity';
            default:
                return null;
        }
    }
    return null;
}
export function isSpecialNaNValue(value) {
    const specialValue = getSpecialFormatData(value);
    if (!specialValue) {
        return isNaN(value);
    }
    return specialValue === 'NaN';
}
export function isSpecialInfinityValue(value) {
    const specialValue = getSpecialFormatData(value);
    if (!specialValue) {
        return false;
    }
    return specialValue === 'Infinity';
}
export function isSpecialMinusInfinityValue(value) {
    return false;
}
export function isSpecialValue(value) {
    return !!getSpecialFormatData(value);
}
export { getNullValuePlaceHolder, getEmptyValuePlaceHolder };
//# sourceMappingURL=special-data-value-format.js.map